import React from "react";
import { Link } from "react-router-dom";
import { getDashboardPath } from "@src/routes/dashboard-paths";
import styles from "./static-tool-widgets.module.scss";
import type { WidgetRendererProps } from "../widget-renderer";

const DEFAULT_COLOR = "#027680";

const fillStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "100%",
};

export const StaticHeaderWidget = ({ presentation }: WidgetRendererProps) => (
  <div style={fillStyle}>
    <span
      style={{
        display: "block",
        width: "100%",
        fontSize: presentation.font_size ?? 32,
        color: presentation.color ?? DEFAULT_COLOR,
        textAlign: presentation.alignment ?? "left",
        fontWeight: 600,
        whiteSpace: "pre-wrap",
        lineHeight: 1.2,
      }}
    >
      {presentation.content ?? ""}
    </span>
  </div>
);

export const StaticTextWidget = ({ presentation }: WidgetRendererProps) => (
  <div style={fillStyle}>
    <span
      style={{
        display: "block",
        width: "100%",
        fontSize: presentation.font_size ?? 16,
        color: presentation.color ?? DEFAULT_COLOR,
        textAlign: presentation.alignment ?? "left",
        whiteSpace: "pre-wrap",
        lineHeight: 1.4,
      }}
    >
      {presentation.content ?? ""}
    </span>
  </div>
);

export const StaticLinkWidget = ({
  presentation,
  preview = false,
}: WidgetRendererProps) => {
  const dashboardId =
    typeof presentation.dashboard_id === "string"
      ? presentation.dashboard_id
      : null;
  const textStyle: React.CSSProperties = {
    display: "block",
    width: "100%",
    fontSize: presentation.font_size ?? 16,
    color: presentation.color ?? DEFAULT_COLOR,
    textAlign: presentation.alignment ?? "left",
    whiteSpace: "pre-wrap",
    lineHeight: 1.4,
  };
  // Link only on the canvas, and only once a dashboard is configured.
  // The picker preview and an unconfigured widget stay plain text so they
  // never need a Router or dangle on a missing target.
  if (dashboardId && !preview) {
    return (
      <div style={fillStyle}>
        <Link
          to={getDashboardPath(dashboardId)}
          className={styles["static-link"]}
          style={textStyle}
        >
          {presentation.content ?? ""}
        </Link>
      </div>
    );
  }
  return (
    <div style={fillStyle}>
      <span style={textStyle}>{presentation.content ?? ""}</span>
    </div>
  );
};

export const StaticSeparatorWidget = ({
  presentation,
}: WidgetRendererProps) => (
  <div style={fillStyle}>
    <hr
      style={{
        width: "100%",
        margin: 0,
        border: "none",
        borderTop: `2px solid ${presentation.color ?? DEFAULT_COLOR}`,
      }}
    />
  </div>
);
